import React, { useState } from 'react';
import { BarWave } from 'react-cssfx-loading';
import { useParams } from 'react-router-dom';
import { useGetAllNewsletterSubcribersQuery, useSendNewsletterEmailMutation } from '../../../../redux/apiSlice';

const GetAllSubscribers = () => {
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState('');
  const { data: newsSubscribers } = useGetAllNewsletterSubcribersQuery();
  const [sendNewsletterEmail] = useSendNewsletterEmailMutation();

  const handleSendEmails = async () => {
    setIsLoading(true);
    if (newsSubscribers && newsSubscribers.length > 0 && id) {
      try {
        await sendNewsletterEmail(id);
        setIsLoading(false);
        setSuccessMsg('Email sent successfully');
        setTimeout(() => {
          setSuccessMsg('');
        }, 2000);
      } catch (error) {
        setIsLoading(false);
        console.error('Failed to send emails', error);
        alert(`Failed to send emails. Error: ${error.data?.message || error.error}`);
      }
    }
  };
  if (!newsSubscribers) {
    return <p>Loading subscribers...</p>;
  }

  if (newsSubscribers.length === 0) {
    return <p className="text-center text-gray-500 mt-4">No subscribers at the moment.</p>;
  }

  return (
    <div className="text-sm py-6">
      {successMsg && <p className="text-gray-400 dark:bg-gray-700 text-center px-4 py-3 rounded relative">{successMsg}</p>}
      <button type="button" onClick={handleSendEmails} className="px-3 py-2 rounded-md xl:text-lg lg:text-md text-sm font-medium bg-gray-600 text-gray-400" style={{ animation: 'pulse 1.5s infinite' }} disabled={isLoading}>
        {isLoading ? 'Sending...' : 'Send Email to All'}
      </button>
      {isLoading && <BarWave color="#54c5fc" height="2rem" width="8rem" />}
      <table className=" my-2 w-full text-sm text-left text-gray-400 dark:text-gray-400">
        <thead className="text-xs text-gray-300 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
          <tr>
            <th scope="col" className="px-4 py-4">
              Subscriber Name
            </th>
          </tr>
        </thead>
        <tbody>
          {newsSubscribers.map((subscriber) => (
            <tr key={subscriber.id}>
              <td className="px-4 py-3 text-sm font-medium text-gray-400">
                {subscriber.email}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default GetAllSubscribers;
